import styled, { css } from 'styled-components';

export const ENTRY_CARD_GAP = 12;
export const ENTRY_CARD_PADDING = 12;

const EntryCardContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: ${ENTRY_CARD_PADDING}px;
  gap: ${ENTRY_CARD_GAP}px;
  border-radius: 3px;
  pointer-events: none;

  a,
  button {
    position: relative;
    z-index: 2;
    pointer-events: auto;
  }
`;

export default EntryCardContainer;

export const entryCardShadowProps = css`
  && {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    border-radius: 3px;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px, rgba(0, 0, 0, 0.23) 0px 1px 2px;
    transition: box-shadow 0.3s, background 0.3s, color 0.3s; // background and color for AddEntryCard button

    &:is(a, button):hover,
    &:is(a, button):active {
      box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px, rgba(0, 0, 0, 0.23) 0px 8px 16px -6px;
    }
  }
`;

/**
 * Renders the border shadow of an entry card. Should be rendered as the first child of the card.
 * Rendering this as a separate element allows it to be a link, without interfering with any other links in the
 * content of the card.
 */
export const EntryCardShadow = styled.a`
  ${entryCardShadowProps}
`;
